export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}form/form-submission`;

    return $resource(url, null, {
        get: {
            method: 'GET',
            url: `${url}/:guid`
        },
        start: {
            method: 'GET',
            url: `${url}/start/:guid`
        },
        quizQuestions: {
            method: 'GET',
            isArray: true,
            url: `${url}/:guid/quiz-questions/`
        },
        submittedAnswers: {
            method: 'GET',
            isArray: true,
            url: `${url}/:guid/submitted-answers/`
        },
        evaluationQuestions: {
            method: 'GET',
            isArray: true,
            url: `${url}/:guid/evaluation-questions/`
        },
        feedbackQuestions: {
            method: 'GET',
            isArray: true,
            url: `${url}/:guid/feedback-questions/`
        },
        surveyQuestions: {
            method: 'GET',
            isArray: true,
            url: `${url}/:guid/survey-questions/`
        },
        update: {
            method: 'PUT',
            url
        },
        batchCreate: {
            method: 'POST',
            url: `${url}/batch-create`
        },
        quizCategoriesOverview: {
            method: 'GET',
            isArray: true,
            url: `${url}/quiz-categories-overview`
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/FormSubmission/index.js